import { useEffect, useState } from "react"

export interface IPosition {
  left: number
  top: number
  w: number
  h: number
}

export const useRandomPosition = (
  id: string, 
  positions: Record<string, IPosition>, 
  setPositions: (pos: Record<string, IPosition>) => void,
  getParent: () =>  HTMLElement | null, 
  getCurrent: () => HTMLElement | null
) => {
  const [left, setLeft] = useState(0)
  const [top, setTop] = useState(0)

  useEffect(() => {
    if (positions[id]) {
      return
    }

    const parent = getParent()
    const current = getCurrent()

    if (!parent || !current) {
      return
    }

    let terminate = false

    const cb = () => {  
      let l = Math.random() * (parent.clientWidth - current.clientWidth)
      let t = Math.random() * (parent.clientHeight - current.clientHeight)

      let ok = true;
      const check = () => {
        Object.values(positions).forEach(({left, top, h, w}) => {
          if (l > left) {
            if (l - left < w ) {ok = false}
          } else {
            if (left -l < current.clientWidth) {ok = false}
          }

          if (t > top) {
            if (t - top < h) {ok = false}
          } else {
            if (top - t < current.clientHeight) {ok = false} 
          }
        })
      }
      check()

      let cnt = 0
      while (!ok && cnt < 10) {
        l = Math.random() * (parent.clientWidth - current.clientWidth)
        t = Math.random() * (parent.clientHeight - current.clientHeight)
        ok = true
        cnt++
        check()
      }
      if (terminate) {return}

      setLeft(l)
      setTop(t)

      setPositions({...positions, [id]: {left: l, top: t, w: current.clientWidth, h: current.clientHeight}})
    }
    const timer = Math.round(Math.random() * 100)
    setTimeout(cb, Math.random() * timer)


    window.addEventListener('resize', cb)

    return () => {
      window.removeEventListener('resize', cb)
      terminate = true
    }
  }, [getParent, getCurrent, positions])

  return {left, top}
}